// import logo from "../assets/images/etechcube_logo_square.png";
import logo from "../assets/images/etechcube_logo_square.png";


const WebApp_Name = "eTechCube";
const company_logo_square = logo;

export { WebApp_Name, company_logo_square };
